import type { ReportDocument, ReportEntryDocument } from "./types";

type GenericGenevaReportTemplateProps = {
  report: ReportDocument;
  entries: ReportEntryDocument[];
};

export default function GenericGenevaReportTemplate({
  report,
  entries,
}: GenericGenevaReportTemplateProps) {
  return (
    <div className="statement-empty-state">
      <h1>{report.reportTitle || report.reportName || "Geneva Report"}</h1>
      <p>This print template is not specialized yet.</p>
      <p>Rows available: {entries.length}</p>
      <p>Columns: {(report.result?.columns || []).join(", ") || "None"}</p>
    </div>
  );
}
